module.exports = __webpack_public_path__ + "static/media/park.7c961426.jpg";